// extracted by mini-css-extract-plugin
export default {"profile-right-side":"ProfileRightSide_profile-right-side__zKH1E","profile-right-side__loader":"ProfileRightSide_profile-right-side__loader__fBzIS"};